var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAvgSession(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1702 5.64475C16.8864 2.74311 23.2468 1.65009 24.8521 1.84211L25.0397 2.78782L24.7396 2.73611C23.2839 2.46017 16.2272 3.33624 9.64283 7.04579C8.80432 7.51802 7.84585 8.16663 6.96283 8.84226C6.00036 9.59685 2.96886 12.2457 2.68066 13.7824C3.1444 10.7831 7.70734 7.40281 11.1702 5.64475Z",
    fill: "#B187FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9377 10.3149C25.9377 10.3149 25.7399 11.5755 25.5098 12.641C24.5897 13.4121 22.3501 14.8502 20.2522 15.5909C20.0931 14.4619 19.383 14.1763 18.6717 13.3564C17.5197 12.0296 17.7792 11.0442 19.3075 10.827C23.8704 10.1811 24.9654 8.74293 25.9361 7.25141C27.6853 4.56833 27.2077 2.15576 27.2077 2.15576C29.6957 6.48035 25.209 11.0023 23.7818 12.1947C23.9116 12.1036 24.7599 11.5451 25.9368 10.3158L25.9377 10.3149Z",
    fill: "#B187FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3942 5.51914C20.4078 5.38387 19.1969 6.1338 19.1794 7.2978C18.8086 7.50759 19.423 7.13861 19.1792 7.2978C19.1794 7.74486 19.8594 8.21335 20.0486 8.61601C20.817 8.64085 20.5808 8.40198 21.0611 8.04036H21.062C21.062 8.04036 20.6497 8.21138 19.9375 8.43497C20.1546 9.00823 20.3673 9.87423 20.6553 10.0895C21.7558 10.9085 22.7818 9.40587 22.8858 8.21335C23.0321 6.57731 22.5536 5.67832 21.3942 5.51822V5.51914Z",
    fill: "#B187FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4522 15.9272H20.1794C20.3902 15.8453 20.6009 15.7597 20.8125 15.6695C25.5424 13.6626 29.5721 9.66891 30.473 6.63867C30.8503 9.46554 28.5266 13.3856 25.4513 15.9272H25.4522Z",
    fill: "#B187FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4316 2.28369C27.4316 2.28369 29.6678 2.73931 30.2861 4.40479C31.5661 7.85261 26.196 11.7476 26.196 11.7476C26.196 11.7476 30.7563 7.54712 29.5693 4.79402C29.0909 3.68339 27.8457 3.34187 27.8457 3.34187L27.4316 2.28369Z",
    fill: "#B187FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.60209 22.2039C6.38217 22.5161 6.07432 23.0514 6.2066 23.8098C4.38224 23.2757 2.76964 21.4167 2.50542 20.8947C0.701426 17.3305 3.1054 13.4043 8.10539 10.6172C3.88506 13.2734 1.95308 16.4912 3.17019 19.2029C3.75487 20.5063 4.87068 21.8429 6.60209 22.2039Z",
    fill: "#B187FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75786 24.4449C7.41103 24.4449 7.94052 23.9154 7.94052 23.2623C7.94052 22.6091 7.41103 22.0796 6.75786 22.0796C6.10469 22.0796 5.5752 22.6091 5.5752 23.2623C5.5752 23.9154 6.10469 24.4449 6.75786 24.4449Z",
    fill: "url(#paint0_linear_2243_5081)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.94483 23.7534C6.94483 23.8567 6.86101 23.9405 6.75879 23.9405C6.65657 23.9405 6.57275 23.8567 6.57275 23.7534C6.57275 23.6502 6.65657 23.5674 6.75879 23.5674C6.86101 23.5674 6.94483 23.6512 6.94483 23.7534Z",
    fill: "url(#paint1_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.75913 23.6451C6.84908 23.6451 6.92472 23.7095 6.94312 23.7943C6.94619 23.782 6.94721 23.7688 6.94721 23.7555C6.94721 23.6522 6.86339 23.5674 6.75913 23.5674C6.65486 23.5674 6.57104 23.6512 6.57104 23.7555C6.57104 23.7688 6.57207 23.782 6.57513 23.7943C6.59251 23.7095 6.66815 23.6451 6.75913 23.6451Z",
    fill: "url(#paint2_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.31066 23.6702C6.28817 23.7479 6.2064 23.7919 6.12871 23.7694C6.05103 23.7469 6.00707 23.6651 6.02956 23.5875C6.05205 23.5098 6.13382 23.4658 6.21151 23.4883C6.28919 23.5108 6.33315 23.5926 6.31066 23.6702Z",
    fill: "url(#paint3_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.19561 23.5455C6.26307 23.565 6.30498 23.6304 6.29987 23.6978C6.30498 23.6886 6.30805 23.6794 6.31111 23.6702C6.3336 23.5926 6.28965 23.5108 6.21196 23.4883C6.13428 23.4658 6.05352 23.5098 6.03001 23.5875C6.02695 23.5977 6.0249 23.6069 6.0249 23.6171C6.05659 23.5568 6.12712 23.5261 6.19458 23.5455L6.19561 23.5455Z",
    fill: "url(#paint4_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.83893 23.4637C5.82053 23.5251 5.76226 23.5619 5.70809 23.5455C5.65391 23.5292 5.62427 23.4668 5.64267 23.4055C5.66107 23.3442 5.71933 23.3074 5.77351 23.3237C5.82768 23.3401 5.85733 23.4024 5.83893 23.4637Z",
    fill: "url(#paint5_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.75987 23.3697C5.80689 23.384 5.83551 23.4331 5.82938 23.4862C5.83244 23.4791 5.83551 23.4719 5.83858 23.4637C5.85698 23.4024 5.82733 23.3401 5.77316 23.3237C5.71898 23.3074 5.66072 23.3442 5.64232 23.4055C5.64027 23.4137 5.63823 23.4208 5.63721 23.429C5.66174 23.381 5.71183 23.3554 5.75885 23.3687L5.75987 23.3697Z",
    fill: "url(#paint6_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.21311 23.6707C7.2356 23.7484 7.31737 23.7924 7.39506 23.7699C7.47274 23.7474 7.5167 23.6656 7.49421 23.5879C7.47172 23.5103 7.38995 23.4663 7.31328 23.4888C7.2356 23.5113 7.19164 23.5931 7.21413 23.6707L7.21311 23.6707Z",
    fill: "url(#paint7_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.32793 23.546C7.26046 23.5655 7.21855 23.6309 7.22366 23.6983C7.21855 23.6891 7.21549 23.6799 7.21242 23.6707C7.18993 23.5931 7.23389 23.5113 7.31157 23.4888C7.38926 23.4663 7.47001 23.5103 7.49352 23.5879C7.49659 23.5982 7.49863 23.6074 7.49863 23.6176C7.46694 23.5573 7.39641 23.5266 7.32895 23.546L7.32793 23.546Z",
    fill: "url(#paint8_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.67661 23.4637C7.695 23.5251 7.75327 23.5619 7.80744 23.5455C7.86162 23.5292 7.89126 23.4668 7.87286 23.4055C7.85446 23.3442 7.7962 23.3074 7.74202 23.3237C7.68785 23.3401 7.65821 23.4024 7.67661 23.4637Z",
    fill: "url(#paint9_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.75531 23.3697C7.70829 23.384 7.67967 23.4331 7.6858 23.4862C7.68274 23.4791 7.67967 23.4719 7.67661 23.4637C7.65821 23.4024 7.68785 23.3401 7.74202 23.3237C7.7962 23.3074 7.85446 23.3442 7.87286 23.4055C7.87491 23.4137 7.87695 23.4208 7.87798 23.429C7.85344 23.381 7.80336 23.3554 7.75634 23.3687L7.75531 23.3697Z",
    fill: "url(#paint10_linear_2243_5081)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.90059 23.0613C6.90059 23.142 6.83517 23.2085 6.7534 23.2085C6.67162 23.2085 6.6062 23.143 6.6062 23.0613C6.6062 22.9795 6.67162 22.9141 6.7534 22.9141C6.83517 22.9141 6.90059 22.9795 6.90059 23.0613Z",
    fill: "url(#paint11_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.75373 22.9754C6.82528 22.9754 6.88457 23.0255 6.89786 23.0929C6.8999 23.0827 6.90092 23.0725 6.90092 23.0623C6.90092 22.9805 6.83448 22.9141 6.75271 22.9141C6.67093 22.9141 6.60449 22.9805 6.60449 23.0623C6.60449 23.0725 6.60552 23.0827 6.60756 23.0929C6.62187 23.0255 6.68116 22.9754 6.75169 22.9754L6.75373 22.9754Z",
    fill: "url(#paint12_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.40174 23.0011C6.38334 23.0624 6.31997 23.0971 6.25863 23.0787C6.1973 23.0603 6.16255 22.997 6.18095 22.9356C6.19935 22.8743 6.26272 22.8396 6.32405 22.858C6.38539 22.8764 6.42014 22.9397 6.40174 23.0011Z",
    fill: "url(#paint13_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.30993 22.9039C6.36308 22.9192 6.39682 22.9703 6.39171 23.0235C6.39579 23.0163 6.39886 23.0092 6.4009 23.001C6.4193 22.9396 6.38455 22.8752 6.32322 22.8579C6.26189 22.8395 6.19851 22.8752 6.18011 22.9356C6.17807 22.9437 6.17603 22.9509 6.17603 22.9591C6.20158 22.912 6.25678 22.8875 6.30993 22.9028L6.30993 22.9039Z",
    fill: "url(#paint14_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.03219 22.8334C6.01788 22.8815 5.97188 22.9101 5.92895 22.8978C5.88602 22.8856 5.86353 22.8355 5.87784 22.7874C5.89215 22.7394 5.93815 22.7108 5.98108 22.7231C6.02401 22.7353 6.0465 22.7854 6.03219 22.8334Z",
    fill: "url(#paint15_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.97133 22.7588C6.00813 22.7701 6.03062 22.8089 6.02653 22.8508C6.02959 22.8457 6.03164 22.8396 6.03368 22.8334C6.04799 22.7854 6.02448 22.7353 5.98257 22.7231C5.93964 22.7108 5.89364 22.7394 5.87933 22.7874C5.87729 22.7936 5.87627 22.7997 5.87524 22.8058C5.89467 22.768 5.93453 22.7476 5.97133 22.7588Z",
    fill: "url(#paint16_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.11357 23.0001C7.13197 23.0614 7.19534 23.0962 7.25667 23.0778C7.318 23.0594 7.35276 22.996 7.33436 22.9347C7.31596 22.8733 7.25258 22.8386 7.19125 22.857C7.12992 22.8754 7.09517 22.9387 7.11357 23.0001Z",
    fill: "url(#paint17_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.20454 22.9029C7.15139 22.9182 7.11766 22.9693 7.12277 23.0225C7.11868 23.0153 7.11561 23.0082 7.11357 23C7.09517 22.9387 7.12992 22.8743 7.19125 22.8569C7.25258 22.8385 7.31596 22.8743 7.33436 22.9346C7.3364 22.9428 7.33845 22.9499 7.33845 22.9581C7.31289 22.9111 7.25769 22.8865 7.20454 22.9019L7.20454 22.9029Z",
    fill: "url(#paint18_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.48481 22.8334C7.49912 22.8815 7.54512 22.9101 7.58805 22.8978C7.63098 22.8856 7.65347 22.8355 7.63916 22.7874C7.62485 22.7394 7.57885 22.7108 7.53592 22.7231C7.49299 22.7353 7.4705 22.7854 7.48379 22.8334L7.48481 22.8334Z",
    fill: "url(#paint19_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.54825 22.7588C7.51145 22.7701 7.48896 22.8089 7.49305 22.8508C7.48998 22.8457 7.48794 22.8396 7.48589 22.8334C7.47158 22.7854 7.49509 22.7353 7.537 22.7231C7.57993 22.7108 7.62593 22.7394 7.64024 22.7874C7.64229 22.7936 7.64331 22.7997 7.64433 22.8058C7.62491 22.768 7.58504 22.7476 7.54825 22.7588Z",
    fill: "url(#paint20_linear_2243_5081)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.85971 22.5334C6.85971 22.5896 6.81371 22.6356 6.75749 22.6356C6.70127 22.6356 6.65527 22.5896 6.65527 22.5334C6.65527 22.4772 6.70127 22.4312 6.75749 22.4312C6.81371 22.4312 6.85971 22.4772 6.85971 22.5334Z",
    fill: "url(#paint21_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.75851 22.4741C6.8086 22.4741 6.84949 22.5088 6.85971 22.5559C6.86073 22.5487 6.86175 22.5415 6.86175 22.5344C6.86175 22.4772 6.81576 22.4312 6.75851 22.4312C6.70127 22.4312 6.65527 22.4772 6.65527 22.5344C6.65527 22.5415 6.65527 22.5487 6.65732 22.5559C6.66754 22.5088 6.70843 22.4741 6.75851 22.4741Z",
    fill: "url(#paint22_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.50915 22.4882C6.49689 22.5311 6.45191 22.5546 6.40898 22.5424C6.36605 22.5301 6.34254 22.4851 6.3548 22.4422C6.36707 22.3993 6.41205 22.3757 6.45498 22.388C6.49791 22.4003 6.52142 22.4452 6.50915 22.4882Z",
    fill: "url(#paint23_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.4456 22.4196C6.4824 22.4309 6.50591 22.4656 6.50285 22.5034C6.50591 22.4983 6.50796 22.4932 6.50898 22.4881C6.52124 22.4452 6.49773 22.4002 6.4548 22.3879C6.41187 22.3757 6.36792 22.4002 6.35463 22.4421C6.35258 22.4472 6.35156 22.4533 6.35156 22.4585C6.36894 22.4257 6.40778 22.4084 6.4456 22.4196Z",
    fill: "url(#paint24_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.25198 22.3782C6.24176 22.4119 6.21007 22.4324 6.18043 22.4232C6.15079 22.414 6.13443 22.3802 6.14465 22.3465C6.15487 22.3128 6.18656 22.2923 6.21621 22.3015C6.24585 22.3107 6.2622 22.3445 6.25198 22.3782Z",
    fill: "url(#paint25_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.20849 22.3261C6.23404 22.3342 6.2504 22.3608 6.24733 22.3905C6.24937 22.3864 6.25142 22.3823 6.25244 22.3782C6.26266 22.3445 6.24631 22.3097 6.21666 22.3015C6.18702 22.2923 6.15431 22.3128 6.14511 22.3465C6.14409 22.3506 6.14307 22.3547 6.14307 22.3598C6.15635 22.3332 6.18395 22.3189 6.21053 22.3271L6.20849 22.3261Z",
    fill: "url(#paint26_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.00446 22.4877C7.01673 22.5306 7.06171 22.5541 7.10464 22.5419C7.14757 22.5296 7.17108 22.4846 7.15881 22.4417C7.14655 22.3988 7.10157 22.3753 7.05864 22.3875C7.01571 22.3998 6.9922 22.4448 7.00446 22.4877Z",
    fill: "url(#paint27_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.06784 22.4191C7.03104 22.4304 7.00753 22.4651 7.0106 22.5029C7.00753 22.4978 7.00548 22.4927 7.00446 22.4876C6.9922 22.4447 7.01571 22.3997 7.05864 22.3874C7.10157 22.3752 7.14552 22.3997 7.15881 22.4416C7.16086 22.4467 7.16188 22.4529 7.16188 22.458C7.1445 22.4253 7.10566 22.4079 7.06784 22.4191Z",
    fill: "url(#paint28_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.26672 22.3787C7.27694 22.4124 7.30863 22.4329 7.33828 22.4237C7.36792 22.4145 7.38427 22.3807 7.37405 22.347C7.36383 22.3133 7.33214 22.2928 7.3025 22.302C7.27286 22.3112 7.2565 22.3449 7.26672 22.3787Z",
    fill: "url(#paint29_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.31068 22.3265C7.28512 22.3347 7.26877 22.3613 7.27183 22.3909C7.26979 22.3869 7.26774 22.3828 7.26672 22.3787C7.2565 22.3449 7.27286 22.3102 7.3025 22.302C7.33214 22.2928 7.36485 22.3133 7.37405 22.347C7.37507 22.3511 7.3761 22.3552 7.3761 22.3603C7.36281 22.3337 7.33521 22.3194 7.30863 22.3276L7.31068 22.3265Z",
    fill: "url(#paint30_linear_2243_5081)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.61708 23.3359C6.61708 23.4136 6.55371 23.4769 6.47602 23.4769C6.39834 23.4769 6.33496 23.4136 6.33496 23.3359C6.33496 23.2582 6.39834 23.1948 6.47602 23.1948C6.55371 23.1948 6.61708 23.2582 6.61708 23.3359Z",
    fill: "url(#paint31_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.47704 23.2541C6.54553 23.2541 6.60277 23.3022 6.61606 23.3666C6.61811 23.3574 6.61913 23.3471 6.61913 23.3369C6.61913 23.2582 6.55575 23.1948 6.47704 23.1948C6.39834 23.1948 6.33496 23.2582 6.33496 23.3369C6.33496 23.3471 6.33598 23.3563 6.33803 23.3666C6.35132 23.3022 6.40856 23.2541 6.47704 23.2541Z",
    fill: "url(#paint32_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.183 23.3383C7.183 23.416 7.11963 23.4794 7.04194 23.4794C6.96425 23.4794 6.90088 23.416 6.90088 23.3383C6.90088 23.2606 6.96425 23.1973 7.04194 23.1973C7.11963 23.1973 7.183 23.2606 7.183 23.3383Z",
    fill: "url(#paint33_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.04296 23.2566C7.11145 23.2566 7.16869 23.3046 7.18198 23.369C7.18402 23.3598 7.18505 23.3496 7.18505 23.3393C7.18505 23.2606 7.12167 23.1973 7.04296 23.1973C6.96425 23.1973 6.90088 23.2606 6.90088 23.3393C6.90088 23.3496 6.9019 23.3588 6.90395 23.369C6.91723 23.3046 6.97448 23.2566 7.04296 23.2566Z",
    fill: "url(#paint34_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.13462 23.2656C6.11724 23.3239 6.05693 23.3566 5.99867 23.3403C5.9404 23.3229 5.90769 23.2626 5.92507 23.2043C5.94245 23.146 6.00275 23.1133 6.06102 23.1297C6.11928 23.1471 6.15199 23.2074 6.13462 23.2656Z",
    fill: "url(#paint35_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.04623 23.173C6.09734 23.1883 6.12903 23.2364 6.12392 23.2875C6.12698 23.2813 6.13005 23.2742 6.13209 23.266C6.14947 23.2077 6.11574 23.1464 6.0585 23.1301C6.00023 23.1127 5.93992 23.1464 5.92255 23.2047C5.9205 23.2118 5.91948 23.22 5.91846 23.2272C5.94299 23.1822 5.99512 23.1587 6.04623 23.174L6.04623 23.173Z",
    fill: "url(#paint36_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.78265 23.1214C5.76834 23.1684 5.72336 23.197 5.68247 23.1848C5.64158 23.1725 5.61807 23.1245 5.63239 23.0774C5.6467 23.0304 5.69167 23.0018 5.73256 23.0141C5.77447 23.0263 5.79696 23.0744 5.78265 23.1214Z",
    fill: "url(#paint37_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.72119 23.0488C5.75799 23.059 5.77946 23.0979 5.77537 23.1388C5.77843 23.1337 5.78048 23.1275 5.78252 23.1214C5.79683 23.0744 5.77435 23.0263 5.73244 23.0141C5.69053 23.0018 5.64555 23.0304 5.63124 23.0774C5.6292 23.0836 5.62817 23.0897 5.62817 23.0958C5.64657 23.059 5.68542 23.0386 5.72221 23.0498L5.72119 23.0488Z",
    fill: "url(#paint38_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.3858 23.2647C7.40317 23.3229 7.46348 23.3556 7.52175 23.3393C7.58001 23.3219 7.61272 23.2616 7.59637 23.2033C7.58001 23.1451 7.51868 23.1124 7.46042 23.1287C7.40215 23.1461 7.36944 23.2064 7.3858 23.2647Z",
    fill: "url(#paint39_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.47374 23.172C7.42263 23.1873 7.39094 23.2354 7.39606 23.2865C7.39299 23.2804 7.38992 23.2732 7.38788 23.265C7.3705 23.2068 7.40423 23.1454 7.46147 23.1291C7.51974 23.1117 7.58005 23.1454 7.59742 23.2037C7.59947 23.2109 7.60049 23.219 7.60151 23.2262C7.57698 23.1812 7.52485 23.1577 7.47374 23.173L7.47374 23.172Z",
    fill: "url(#paint40_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.73883 23.1214C7.75314 23.1684 7.79812 23.197 7.839 23.1848C7.88091 23.1725 7.9034 23.1245 7.88909 23.0774C7.87478 23.0304 7.8298 23.0018 7.78892 23.0141C7.74803 23.0263 7.72452 23.0744 7.73883 23.1214Z",
    fill: "url(#paint41_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.79831 23.0488C7.76151 23.059 7.74004 23.0979 7.74413 23.1388C7.74107 23.1337 7.73902 23.1275 7.73698 23.1214C7.72267 23.0744 7.74515 23.0263 7.78706 23.0141C7.82897 23.0018 7.87395 23.0304 7.88826 23.0774C7.8903 23.0836 7.89133 23.0897 7.89133 23.0958C7.87293 23.059 7.83408 23.0386 7.79729 23.0498L7.79831 23.0488Z",
    fill: "url(#paint42_linear_2243_5081)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.54556 22.8558C6.60484 22.8558 6.65289 22.8077 6.65289 22.7484C6.65289 22.6892 6.60484 22.6411 6.54556 22.6411C6.48629 22.6411 6.43823 22.6892 6.43823 22.7484C6.43823 22.8077 6.48629 22.8558 6.54556 22.8558Z",
    fill: "url(#paint43_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.54658 22.6861C6.59872 22.6861 6.64267 22.7229 6.65289 22.772C6.65391 22.7648 6.65494 22.7576 6.65494 22.7495C6.65494 22.6892 6.60689 22.6411 6.54658 22.6411C6.48628 22.6411 6.43823 22.6892 6.43823 22.7495C6.43823 22.7566 6.43823 22.7648 6.44028 22.772C6.4505 22.7229 6.49445 22.6861 6.54658 22.6861Z",
    fill: "url(#paint44_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.97549 22.8558C7.03477 22.8558 7.08282 22.8077 7.08282 22.7484C7.08282 22.6892 7.03477 22.6411 6.97549 22.6411C6.91622 22.6411 6.86816 22.6892 6.86816 22.7484C6.86816 22.8077 6.91622 22.8558 6.97549 22.8558Z",
    fill: "url(#paint45_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.97456 22.6861C7.02669 22.6861 7.07065 22.7229 7.08087 22.772C7.08189 22.7648 7.08291 22.7576 7.08291 22.7495C7.08291 22.6892 7.03487 22.6411 6.97456 22.6411C6.91425 22.6411 6.86621 22.6892 6.86621 22.7495C6.86621 22.7566 6.86621 22.7648 6.86826 22.772C6.87848 22.7229 6.92243 22.6861 6.97456 22.6861Z",
    fill: "url(#paint46_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.2829 22.6976C6.26961 22.7416 6.22361 22.7671 6.17864 22.7538C6.13468 22.7406 6.10913 22.6946 6.12242 22.6496C6.1357 22.6056 6.1817 22.5801 6.22566 22.5934C6.26961 22.6067 6.29517 22.6527 6.28188 22.6976L6.2829 22.6976Z",
    fill: "url(#paint47_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.21532 22.6271C6.25416 22.6383 6.27767 22.6751 6.2746 22.714C6.27767 22.7089 6.27971 22.7038 6.28074 22.6976C6.29402 22.6537 6.26847 22.6066 6.22452 22.5934C6.18056 22.5801 6.13354 22.6056 6.12025 22.6506C6.11821 22.6567 6.11719 22.6618 6.11719 22.668C6.13559 22.6332 6.17545 22.6158 6.21429 22.6271L6.21532 22.6271Z",
    fill: "url(#paint48_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M6.01199 22.5854C6.00177 22.6211 5.96701 22.6426 5.93533 22.6334C5.90364 22.6242 5.88626 22.5874 5.89648 22.5516C5.90671 22.5159 5.94146 22.4944 5.97315 22.5036C6.00484 22.5128 6.02221 22.5496 6.01199 22.5854Z",
    fill: "url(#paint49_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M5.96613 22.5302C5.99373 22.5383 6.01008 22.567 6.00702 22.5987C6.00906 22.5946 6.01111 22.5905 6.01213 22.5854C6.02235 22.5496 6.00599 22.5128 5.97328 22.5036C5.9416 22.4944 5.90684 22.5159 5.89662 22.5516C5.8956 22.5557 5.89458 22.5608 5.89355 22.5649C5.90787 22.5373 5.93751 22.522 5.96511 22.5302L5.96613 22.5302Z",
    fill: "url(#paint50_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.23496 22.6976C7.24825 22.7416 7.29425 22.7671 7.33821 22.7538C7.38216 22.7406 7.40771 22.6946 7.39442 22.6496C7.38114 22.6056 7.33514 22.5801 7.29118 22.5934C7.24723 22.6067 7.22168 22.6527 7.23496 22.6976Z",
    fill: "url(#paint51_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.30038 22.6271C7.26154 22.6383 7.23803 22.6751 7.2411 22.714C7.23803 22.7089 7.23599 22.7038 7.23496 22.6976C7.22168 22.6537 7.24723 22.6066 7.29118 22.5934C7.33514 22.5801 7.38216 22.6056 7.39545 22.6506C7.39749 22.6567 7.39851 22.6618 7.39851 22.668C7.38011 22.6332 7.34025 22.6158 7.30141 22.6271L7.30038 22.6271Z",
    fill: "url(#paint52_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.50317 22.5854C7.5134 22.6211 7.54815 22.6426 7.57984 22.6334C7.61153 22.6242 7.6289 22.5874 7.61868 22.5516C7.60846 22.5159 7.57371 22.4944 7.54202 22.5036C7.51033 22.5128 7.49295 22.5496 7.50317 22.5854Z",
    fill: "url(#paint53_linear_2243_5081)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M7.55098 22.5302C7.52338 22.5383 7.50702 22.567 7.51009 22.5987C7.50805 22.5946 7.506 22.5905 7.50498 22.5854C7.49476 22.5496 7.51111 22.5128 7.54382 22.5036C7.57551 22.4944 7.61026 22.5159 7.62049 22.5516C7.62151 22.5557 7.62253 22.5608 7.62355 22.5649C7.60924 22.5373 7.5796 22.522 7.552 22.5302L7.55098 22.5302Z",
    fill: "url(#paint54_linear_2243_5081)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.1,
    d: "M1.89922 21.925C1.28897 21.925 0.788105 21.4629 0.723708 20.8711C0.719619 20.913 0.716553 20.9559 0.716553 20.9989C0.716553 21.652 1.24604 22.1815 1.89922 22.1815C2.55239 22.1815 3.08188 21.652 3.08188 20.9989C3.08188 20.9559 3.07984 20.913 3.07472 20.8711C3.01033 21.464 2.50946 21.925 1.89922 21.925Z",
    fill: "url(#paint55_linear_2243_5081)"
  }), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3835 1.01315C26.9703 1.17765 27.1154 2.05026 27.1485 2.51272L27.1508 2.51454C27.209 3.32583 27.011 4.48229 27.011 4.48229C27.0017 4.0797 26.7971 3.46663 26.3384 3.25818C25.9583 3.0858 25.5017 3.14836 25.1857 2.76677C25.1477 2.72082 25.115 2.67252 25.0864 2.62291C24.802 1.98661 24.6633 0.773825 26.3835 1.01315Z",
    fill: "#B187FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2243_5081",
    x1: 6.75786,
    y1: 22.099,
    x2: 6.75786,
    y2: 24.4061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FAFCFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EFF6FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#DEECFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#C5DEFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C4DEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2243_5081",
    x1: 6.38161,
    y1: 22.0862,
    x2: 6.66066,
    y2: 23.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2243_5081",
    x1: 6.38092,
    y1: 22.0873,
    x2: 6.661,
    y2: 23.32,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2243_5081",
    x1: 6.19102,
    y1: 23.3205,
    x2: 6.10994,
    y2: 24.5828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2243_5081",
    x1: 6.21946,
    y1: 23.3385,
    x2: 6.13844,
    y2: 24.5999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2243_5081",
    x1: 5.78736,
    y1: 22.9709,
    x2: 5.74003,
    y2: 24.226,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2243_5081",
    x1: 5.77216,
    y1: 22.9648,
    x2: 5.72849,
    y2: 24.2191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2243_5081",
    x1: 7.29633,
    y1: 22.7558,
    x2: 7.37713,
    y2: 24.0172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2243_5081",
    x1: 7.79432,
    y1: 22.5457,
    x2: 7.87284,
    y2: 23.8076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2243_5081",
    x1: 7.28823,
    y1: 22.7794,
    x2: 7.33556,
    y2: 24.0344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2243_5081",
    x1: 7.82424,
    y1: 22.5483,
    x2: 7.8682,
    y2: 23.8036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2243_5081",
    x1: 6.52545,
    y1: 22.0513,
    x2: 6.8045,
    y2: 23.2851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2243_5081",
    x1: 6.52476,
    y1: 22.0513,
    x2: 6.80382,
    y2: 23.2841,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2243_5081",
    x1: 6.26839,
    y1: 23.33,
    x2: 6.1876,
    y2: 24.5914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2243_5081",
    x1: 6.29684,
    y1: 23.3481,
    x2: 6.21583,
    y2: 24.6094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2243_5081",
    x1: 5.94674,
    y1: 22.9763,
    x2: 5.89941,
    y2: 24.2314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2243_5081",
    x1: 5.93068,
    y1: 22.9687,
    x2: 5.88811,
    y2: 24.2232,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2243_5081",
    x1: 7.20919,
    y1: 22.7629,
    x2: 7.28999,
    y2: 24.0243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2243_5081",
    x1: 7.70894,
    y1: 22.5545,
    x2: 7.78717,
    y2: 23.8154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2243_5081",
    x1: 7.13031,
    y1: 22.7848,
    x2: 7.17764,
    y2: 24.0398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2243_5081",
    x1: 7.66908,
    y1: 22.5521,
    x2: 7.71304,
    y2: 23.8074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2243_5081",
    x1: 6.64301,
    y1: 22.0305,
    x2: 6.92308,
    y2: 23.2632,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2243_5081",
    x1: 6.64403,
    y1: 22.0315,
    x2: 6.92308,
    y2: 23.2642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2243_5081",
    x1: 6.37742,
    y1: 23.3365,
    x2: 6.29634,
    y2: 24.5989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2243_5081",
    x1: 6.40551,
    y1: 23.3535,
    x2: 6.32421,
    y2: 24.6159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2243_5081",
    x1: 6.1484,
    y1: 22.9921,
    x2: 6.10107,
    y2: 24.2471,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2243_5081",
    x1: 6.13225,
    y1: 22.9843,
    x2: 6.08857,
    y2: 24.2386,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2243_5081",
    x1: 7.09978,
    y1: 22.7709,
    x2: 7.18058,
    y2: 24.0322,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2243_5081",
    x1: 7.60025,
    y1: 22.5602,
    x2: 7.67877,
    y2: 23.8221,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2243_5081",
    x1: 6.93007,
    y1: 22.8001,
    x2: 6.97768,
    y2: 24.0561,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2243_5081",
    x1: 7.46813,
    y1: 22.5683,
    x2: 7.51209,
    y2: 23.8236,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2243_5081",
    x1: 6.2031,
    y1: 22.1297,
    x2: 6.48215,
    y2: 23.3625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2243_5081",
    x1: 6.2031,
    y1: 22.1307,
    x2: 6.48216,
    y2: 23.3635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2243_5081",
    x1: 6.74142,
    y1: 22.0105,
    x2: 7.02047,
    y2: 23.2433,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2243_5081",
    x1: 6.74244,
    y1: 22.0115,
    x2: 7.0215,
    y2: 23.2443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2243_5081",
    x1: 6.02527,
    y1: 23.3117,
    x2: 5.94448,
    y2: 24.5731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2243_5081",
    x1: 6.05106,
    y1: 23.3299,
    x2: 5.96975,
    y2: 24.5922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2243_5081",
    x1: 5.72306,
    y1: 22.972,
    x2: 5.67544,
    y2: 24.228,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2243_5081",
    x1: 5.70881,
    y1: 22.9661,
    x2: 5.66485,
    y2: 24.2214,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2243_5081",
    x1: 7.45506,
    y1: 22.699,
    x2: 7.53614,
    y2: 23.9614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2243_5081",
    x1: 7.94177,
    y1: 22.4981,
    x2: 8.02001,
    y2: 23.759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2243_5081",
    x1: 7.36675,
    y1: 22.7511,
    x2: 7.41408,
    y2: 24.0062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2243_5081",
    x1: 7.88692,
    y1: 22.5283,
    x2: 7.9306,
    y2: 23.7825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2243_5081",
    x1: 6.3953,
    y1: 22.084,
    x2: 6.67436,
    y2: 23.3168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2243_5081",
    x1: 6.39632,
    y1: 22.084,
    x2: 6.67538,
    y2: 23.3178,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2243_5081",
    x1: 6.80377,
    y1: 21.991,
    x2: 7.08282,
    y2: 23.2238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2243_5081",
    x1: 6.80284,
    y1: 21.992,
    x2: 7.08291,
    y2: 23.2248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2243_5081",
    x1: 6.16245,
    y1: 23.3205,
    x2: 6.08137,
    y2: 24.5828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2243_5081",
    x1: 6.18831,
    y1: 23.3392,
    x2: 6.10729,
    y2: 24.6006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2243_5081",
    x1: 5.92389,
    y1: 22.9773,
    x2: 5.87627,
    y2: 24.2334,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2243_5081",
    x1: 5.90863,
    y1: 22.9711,
    x2: 5.86496,
    y2: 24.2254,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2243_5081",
    x1: 7.31635,
    y1: 22.7088,
    x2: 7.39645,
    y2: 23.9714,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2243_5081",
    x1: 7.80227,
    y1: 22.5071,
    x2: 7.8808,
    y2: 23.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2243_5081",
    x1: 7.16063,
    y1: 22.7565,
    x2: 7.20796,
    y2: 24.0115,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2243_5081",
    x1: 7.68339,
    y1: 22.5322,
    x2: 7.72735,
    y2: 23.7875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3E97FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2243_5081",
    x1: 1.89922,
    y1: 21.6971,
    x2: 1.89922,
    y2: 22.1335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#126DD6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvgSession);
export default __webpack_public_path__ + "static/media/avgSession.d82bbf9f7e3a8fa52c08b196cf7a56b5.svg";
export { ForwardRef as ReactComponent };